import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState, useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import useEffectAsync from '../../../utilities/hooks/useEffectAsync';
import Config from '../../../Config';
import StripBannerBlock from '../StripBannerBlock/StripBannerBlock';
import NewDalpakItemsBlock from '../NewDalpakItemsBlock';
import { ROLE_TYPE } from './IdfMainPageEnum';
import { GetUserDetails } from '../IdfSaleBlock/IdfSaleSlice';
import FAQItemsBlock from '../FAQItemsBlock';
import PopUp from '../../Shared/Popup/PopUp';
import ActionsErrorPopUp from './ActionsErrorPopUp';
import DisconnectPopUp from './DisconnectPopUp';
import BtnWhite from '../../Shared/Buttons/BtnWhiteBlackBorderSmallSize';
import { prepareSameWindowUrlWithNavigateTo } from '../../../utilities/StringHelpers/StringHelpers';
import { createWorkOrderAsync } from '../IdfSaleBlock/IdfSaleSlice';
import EpiContext from "@episerver/spa-core/Spa";
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';
import { dwhReport, dwhDictionary } from '../IdfSaleBlock/dwhReports/dwhGeneralReport';
import { refreshToken } from 'app/utilities/authentication/authenticationSlice';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
const Banner = (props) => (
  <div className='main-banner-container'>
    <Image src={`${props.epiBaseUrl}${isMobile ? props.item.backGroundMobileImage.value?.url : props.item.backGroundDesktopImage.value?.url}`}
      alt='Background'
      style={{
        width: '100%',
        height: '100%',
        zIndex: '-1',
        objectFit: 'cover',
        objectPosition: 'centerTop',
      }} />
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '44px',
        textAlign: 'center',
      }}>
      <span className='hello-name-title'>
        שלום{' '}
        {props?.userDetails?.first_name &&
          props?.userDetails?.last_name &&
          props?.userDetails?.first_name + ' ' + props?.userDetails?.last_name}
      </span>
      <div className='welcome-title' dangerouslySetInnerHTML={{ __html: props.item.mainTitle.value }}></div>
    </div>
  </div>
);

const IdfMainPage = (props) => {
  const [processType, setProcessType] = useState('MAIN_PAGE');
  const [showPopup, setShowPopup] = useState(false);
  const [showDisconnectPopup, setDisconnectShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({ title: '', desc: '', subDesc: '' });
  const role = props.auth?.loginData?.userDetails?.RoleList?.[0] ?? '';
  const epiBaseUrl = Config?.epiBaseUrl;
  const isIDFCustomer = props.auth.loginData?.userDetails?.RoleList?.some(role => role.startsWith('IDFOTP')) ?? false;

  useLayoutEffect(() => {
    if (props.auth.loginData?.isFullAuthenticated) {
      if (!isIDFCustomer) {
        EpiContext.navigateTo(Config.lobbyUrl)
      }
    }
  }, []);
  useEffectAsync(async () => {
    if (props.auth.loginData?.isFullAuthenticated) {
      if (isNullOrEmpty(props?.idfStore?.userDetails)) {
        const res = await props.GetUserDetails();
      }
    } else {
      EpiContext.navigateTo(Config.idfLoginUrl)
    }
  }, [props.auth.loginData?.isFullAuthenticated, GetUserDetails]);

  const [showEcommerceBanner, setShowEcommerceBanner] = useState(false);

  let pageLoadCounter = parseInt(sessionStorage.getItem('pageLoadCounter')) || 0;
  var data = props.iContent;

  useEffect(() => {
    if (pageLoadCounter > 3) {
      setShowEcommerceBanner(true);
    }
  }, [props.auth.loginData?.userDetails?.RoleList]);

  function onClick(item) {
    switch (item.bannerType.value) {
      case 'JOIN':
        dwhReport({ ...dwhDictionary.SelectedJoinBanner });
      case 'ORDER_INFO':
        props.context.navigateTo(item?.navigationPageLink?.value);
        break;
      case 'UPGRADE_CELL':
        if (role === ROLE_TYPE.IDFOTP_NEWCUSTOMER) {
          props.context.navigateTo(props.iContent.joinLink.value);
        } else if (role === ROLE_TYPE.IDFOTP_NEWCUSTOMER_DONE) {
          if (props?.idfStore?.canUpgradePhone) {
            props.context.navigateTo(item?.navigationPageLink?.value);
          } else {
            setShowPopup(true);
          }
        } else if (role === ROLE_TYPE.IDFOTP_NEWCUSTOMER_ERROR) {
          setShowPopup(true);
        } else if (role === ROLE_TYPE.IDFOTP_CUSTOMEREXIST) {
          props.context.navigateTo(item?.navigationPageLink?.value);
        }
        break;
      case 'FAMILY_MEMBER':
        if (role === ROLE_TYPE.IDFOTP_NEWCUSTOMER) {
          setShowPopup(true);
        } else if (role === ROLE_TYPE.IDFOTP_NEWCUSTOMER_DONE) {
          setShowPopup(true);
        } else if (role === ROLE_TYPE.IDFOTP_NEWCUSTOMER_ERROR) {
          setShowPopup(true);
        } else if (role === ROLE_TYPE.IDFOTP_CUSTOMEREXIST) {
          props.context.navigateTo(item.navigationPageLink.value);
        }
        break;
      case 'ECOMMERCE':
        break;
      default:
        if (role === ROLE_TYPE.IDFOTP_NEWCUSTOMER) {
          setShowPopup(true);
        } else if (role === ROLE_TYPE.IDFOTP_NEWCUSTOMER_DONE) {
          setShowPopup(true);
        } else if (role === ROLE_TYPE.IDFOTP_NEWCUSTOMER_ERROR) {
          setShowPopup(true);
        } else if (role === ROLE_TYPE.IDFOTP_CUSTOMEREXIST) {
          props.context.navigateTo(item.navigationPageLink.value);
        }
        break;
    }
    // console.log(item);
  }

  const actionCallback= async(link)=> {
    if (link.isDelivery) {
      if (role === ROLE_TYPE.IDFOTP_NEWCUSTOMER || role === ROLE_TYPE.IDFOTP_NEWCUSTOMER_ERROR) {
        setShowPopup(true);
      } else if (role === ROLE_TYPE.IDFOTP_NEWCUSTOMER_DONE || role === ROLE_TYPE.IDFOTP_CUSTOMEREXIST) {
        props.context.navigateTo(link?.href);
      }
    } else {
      if (
        role === ROLE_TYPE.IDFOTP_NEWCUSTOMER ||
        role === ROLE_TYPE.IDFOTP_NEWCUSTOMER_ERROR ||
        role === ROLE_TYPE.IDFOTP_NEWCUSTOMER_DONE
      ) {
        setShowPopup(true);
      } else if (role === ROLE_TYPE.IDFOTP_CUSTOMEREXIST) {
        props.context.navigateTo(link?.href);
      }
      else if (role === ROLE_TYPE.IDFOTP_CUSTOMER_EXIST_BEFOREACTIVE) {
        props.showAppLoader()
        const refreshResult = await props.refreshToken();
        props.hideAppLoader();
        const updatedRoleList= refreshResult?.payload?.payload?.RoleList;
        var custumerExist = updatedRoleList?.some(role => role == ROLE_TYPE.IDFOTP_CUSTOMEREXIST);  
        if(custumerExist){
          props.context.navigateTo(link?.href);
        }else{
         setShowPopup(true);
        }
      } 
    }
    return null;
  }
  const findFirstMatchingObject = () => {
    const originalObjects = props.iContent?.personalActions?.expandedValue;
    if (!originalObjects) return [];

    for (const obj of originalObjects) {
      const matches = obj.operationBoxItems.expandedValue;

      if (matches.length > 0) {
        const modifiedObject = {
          ...obj,
          operationBoxItems: {
            ...obj.operationBoxItems,
            expandedValue: matches,
          },
        };
        return [modifiedObject];
      }
    }

    return [];
  };

  async function createWorkOrder() {
    const res = await props.createWorkOrderAsync({ isDisplayLoader: true });
    props.context.navigateTo(props.iContent.joinBannerLink.value);
  }

  function filterBanners(item, role, showEcommerceBanner) {
    // Check based on role
    if (role === ROLE_TYPE.IDFOTP_NEWCUSTOMER && item.bannerType.value === 'ORDER_INFO') {
      return false; // Exclude 'ORDER_INFO' for IDFOTP_NEWCUSTOMER
    } else if (role === ROLE_TYPE.IDFOTP_NEWCUSTOMER_DONE && item.bannerType.value === 'JOIN') {
      return false; // Exclude 'JOIN' for IDFOTP_NEWCUSTOMER_DONE
    } else if (
      role === ROLE_TYPE.IDFOTP_NEWCUSTOMER_ERROR &&
      (item.bannerType.value === 'JOIN' || item.bannerType.value === 'ORDER_INFO')
    ) {
      return false; // Exclude 'JOIN' for IDFOTP_NEWCUSTOMER_DONE
    } else if (role === ROLE_TYPE.IDFOTP_CUSTOMEREXIST && (item.bannerType.value === 'JOIN' || item.bannerType.value === 'ORDER_INFO')) {
      return false; // Exclude 'JOIN' for IDFOTP_NEWCUSTOMER_DONE
    }
    // Check for ECOMMERCE banner
    if (!showEcommerceBanner && item.bannerType.value === 'ECOMMERCE') {
      return false; // Exclude 'ECOMMERCE' if showEcommerceBanner is false
    }

    return true; // Include item if none of the above conditions match
  }
  const firstMatchingObject = findFirstMatchingObject();
  const renderMainPage = () => (
    <>
      {props.iContent?.mainBanner?.expandedValue?.map((item, index) => (
        <Banner key={`mainBanner-${index}`} epiBaseUrl={epiBaseUrl} item={item} userDetails={props.idfStore.userDetails} />
      ))}

      <div className='top-banners-container'>
        {props.iContent?.topBanners?.expandedValue
          ?.filter((item) => filterBanners(item, role, showEcommerceBanner))
          .map((item, index) => (
            <div key={`topBanner-${index}`} className='strip-banner-block'>
              <StripBannerBlock onClick={() => onClick(item)} iContent={item} context={props.context}></StripBannerBlock>
            </div>
          ))}
      </div>

      <div className='personal-actions-container'>
        {firstMatchingObject.length > 0 && (
          <NewDalpakItemsBlock key='personalAction-0' data={firstMatchingObject[0]} actionCallback={actionCallback} />
        )}
      </div>
      <div className='bottom-banners-container'>
        {props.iContent?.bottomBanners?.expandedValue.map((item, index) => (
          <div key={`bottomBanner-${index}`} className='strip-banner-block'>
            <StripBannerBlock onClick={() => onClick(item)} iContent={item} context={props.context}></StripBannerBlock>
          </div>
        ))}
      </div>
      <div className='faq-container'>
        {props.iContent.faq.expandedValue.map((item) => {
          return <FAQItemsBlock data={item}></FAQItemsBlock>;
        })}
      </div>
      <div className='bottom-banner-container'>
        <div className='main-banner-header'>{props?.iContent?.bottomBannerMainTitle?.value}</div>
        <div className='second-header'>{props?.iContent?.bottomBannerSecondTitle?.value}</div>
        <BtnWhite onclick={() => createWorkOrder()} text={props?.iContent?.bottomBannerButton?.value}></BtnWhite>
      </div>
    </>
  );


  return (
    <div className='idf-main-page-container'>
      <div className='idf-main-page-container'>
        <div className='main-header'>
          <div className='logo'>
            {isMobile ? (
              <svg width='84' height='44' viewBox='0 0 84 44' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M83.529 11.813c-.11.252-.162.498-.304.668-.322.39-.656.782-1.044 1.101-1.122.925-2.276 1.81-3.413 2.717-.922.736-1.853 1.465-2.641 2.352a10.16 10.16 0 0 0-.85 1.11c-.294.44-.303.908-.093 1.412.493 1.184 1.101 2.306 1.723 3.423 1.72 3.085 3.383 6.2 4.915 9.384.284.59.478 1.225.711 1.84a.74.74 0 0 1 .043.202c.028.336-.125.53-.45.466-.357-.07-.724-.18-1.036-.36a43.81 43.81 0 0 1-2.268-1.412c-2.404-1.583-4.8-3.18-7.202-4.766-.973-.643-1.974-1.236-3.052-1.686-.82-.342-1.665-.53-2.56-.452-.679.06-1.306.281-1.913.575-1.09.529-2.072 1.233-3.035 1.96-1.927 1.454-3.839 2.929-5.763 4.387-.414.314-.853.598-1.288.883-.171.111-.357.209-.549.277-.296.105-.499-.05-.454-.363.037-.256.114-.51.209-.752.508-1.29 1.009-2.585 1.547-3.864.864-2.051 1.763-4.088 2.631-6.138.31-.733.575-1.483.737-2.27.188-.914-.065-1.638-.84-2.149-.434-.285-.895-.528-1.348-.784-.322-.183-.652-.35-.973-.533a4.472 4.472 0 0 1-.513-.341c-.516-.4-.487-.881.103-1.15a24.69 24.69 0 0 1 2.054-.822c1.07-.377 2.155-.71 3.23-1.076.4-.136.788-.309 1.182-.467a5.023 5.023 0 0 0 2.396-1.999c.577-.9 1.082-1.848 1.633-2.767.26-.435.526-.873.842-1.267.181-.225.447-.41.712-.532.5-.232.86-.127 1.192.314.214.284.392.597.575.903.339.566.659 1.143 1.006 1.703.311.503.772.824 1.35.931.374.07.765.127 1.14.09a83.334 83.334 0 0 0 3.58-.434c1.867-.266 3.728-.576 5.596-.835.51-.07 1.038-.042 1.557-.024.21.008.434.079.622.178.126.066.198.234.303.367'
                  fill='var(--theme-primary, #810ea9)'
                />
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M6.666 18.33v-3.99c0-.916-.404-1.262-1.253-1.262H2.727v5.253h3.939zM0 10.454h5.414c2.909 0 3.98.998 3.98 4.011v6.515H0V10.453zM11.96 13.202h-1.515v-2.749h4.263V20.98H11.96v-7.777zM16.734 23.894h2.748V15.18h-2.748v8.714zm3.995-3.607 2.303-7.085h-6.727v-2.749h9.757v1.242l-2.445 9.04H20.75l-.02-.448zM29.435 20.556l2.828-7.35H26.79v-5.05h2.767v2.3h6.04v1.386l-3.171 9.141h-2.99v-.427zM44.07 15.748c0-1.486-.464-2.545-2.383-2.545H39.99c-.303.692-.525 1.507-.504 2.321 0 1.995.99 2.993 2.343 2.993 1.434 0 2.242-1.16 2.242-2.769m-7.173.365c0-1.079.282-2.076.666-2.911h-1.11v-2.749h5.09c3.797 0 5.252 1.812 5.252 5.212 0 3.258-1.98 5.477-5.03 5.477-3.01 0-4.868-2.076-4.868-5.029'
                  fill='#fff'
                />
                <path
                  d='M9.869 36.496v-.288l2.754-7.452h-5.49v-3.6h1.566v2.034h5.814V28l-2.988 8.496H9.869zM15.461 29.962a16.66 16.66 0 0 0-.09-4.338h1.53c.108 1.476-.036 2.916-.378 4.338h-1.062zm2.376-4.338h1.548a14.618 14.618 0 0 1-.396 4.338h-1.044a17.486 17.486 0 0 0-.108-4.338zM27.21 36.496v-7.74h-6.427V27.19h7.992v9.306H27.21zm-6.03 0v-5.508h1.601v5.508H21.18zM30.73 36.496V34.93h5.273c-2.052-2.214-3.852-4.572-5.58-7.398v-.342h1.728a52.254 52.254 0 0 0 2.97 4.41c.846-.396 1.548-1.458 1.62-2.862l.036-1.548h1.692l-.126 1.62c-.18 2.214-1.278 3.204-2.394 3.798a48.71 48.71 0 0 0 2.448 2.808l-.198 1.08h-7.47z'
                  fill='#fff'
                />
              </svg>
            ) : (
              <svg width='152' height='36' viewBox='0 0 152 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M151.887 4.965c-.138.308-.202.608-.378.816-.401.475-.816.953-1.298 1.343-1.396 1.127-2.83 2.207-4.244 3.313-1.147.898-2.305 1.786-3.285 2.868-.383.424-.737.88-1.057 1.353-.365.538-.376 1.107-.115 1.723.613 1.444 1.369 2.812 2.142 4.174 2.138 3.762 4.207 7.56 6.112 11.443.354.72.595 1.494.884 2.245.03.078.047.163.054.245.034.411-.156.647-.561.57-.443-.086-.899-.22-1.288-.44a54.911 54.911 0 0 1-2.82-1.721c-2.989-1.93-5.968-3.877-8.955-5.813-1.21-.784-2.455-1.507-3.796-2.056-1.018-.417-2.07-.647-3.183-.551-.844.072-1.624.343-2.378.701-1.357.645-2.577 1.504-3.775 2.39-2.396 1.774-4.773 3.572-7.166 5.35-.515.383-1.06.73-1.602 1.077a3.282 3.282 0 0 1-.682.338c-.369.129-.62-.062-.564-.443.045-.312.141-.622.259-.916.632-1.575 1.255-3.154 1.924-4.713 1.074-2.502 2.192-4.985 3.272-7.485.386-.894.715-1.809.916-2.769.234-1.115-.081-1.997-1.044-2.62-.54-.348-1.114-.645-1.677-.957-.4-.222-.81-.425-1.209-.65a5.634 5.634 0 0 1-.639-.415c-.641-.487-.606-1.075.128-1.403.834-.373 1.69-.704 2.555-1.002 1.331-.46 2.68-.866 4.016-1.312.498-.166.98-.377 1.469-.57a6.217 6.217 0 0 0 2.98-2.437c.718-1.1 1.346-2.255 2.031-3.375.324-.531.654-1.065 1.047-1.545.225-.275.556-.5.885-.65.623-.282 1.07-.154 1.483.384.266.346.487.728.715 1.101.421.69.819 1.394 1.25 2.077a2.45 2.45 0 0 0 1.679 1.136c.465.084.952.154 1.417.11 1.488-.145 2.974-.322 4.454-.53 2.321-.325 4.635-.702 6.957-1.018.636-.086 1.292-.051 1.937-.029.262.01.54.095.773.216.156.081.247.286.377.447z'
                  fill='var(--theme-primary, #810ea9)'
                />
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M64.428 24.265V19.4c0-1.118-.502-1.54-1.558-1.54h-3.34v6.406h4.898zm-8.291-9.609h6.732c3.617 0 4.949 1.217 4.949 4.892v7.945H56.137V14.656zM71.009 18.008h-1.884v-3.352h5.3v12.837H71.01v-9.485zM76.94 31.04h3.416V20.415H76.94v10.627zm4.973-4.391 2.864-8.64h-8.365v-3.353h12.133v1.515l-3.04 11.024H81.94l-.026-.546zM92.742 26.973l3.516-8.964h-6.807v-6.157h3.441v2.805h7.511v1.689l-3.944 11.148h-3.717v-.521zM110.93 21.112c0-1.813-.578-3.104-2.964-3.104h-2.11c-.377.844-.653 1.837-.628 2.83 0 2.433 1.231 3.65 2.914 3.65 1.783 0 2.788-1.415 2.788-3.376zm-8.918.447c0-1.316.351-2.533.829-3.55h-1.382v-3.353h6.33c4.722 0 6.531 2.21 6.531 6.357 0 3.972-2.462 6.679-6.254 6.679-3.744 0-6.054-2.533-6.054-6.133z'
                  fill='#fff'
                />
                <path
                  d='M16.06 28v-.32l3.06-8.28h-6.1v-4h1.74v2.26h6.46v.9L17.9 28h-1.84zm6.246-7.26c.18-1.62.14-3.22-.1-4.82h1.7c.12 1.64-.04 3.24-.42 4.82h-1.18zm2.64-4.82h1.72c.1 1.64-.06 3.24-.44 4.82h-1.16c.16-1.62.12-3.22-.12-4.82zM35.393 28v-8.6h-7.14v-1.74h8.88V28h-1.74zm-6.7 0v-6.12h1.78V28h-1.78zm10.644 0v-1.74h5.86c-2.28-2.46-4.28-5.08-6.2-8.22v-.38h1.92a58.06 58.06 0 0 0 3.3 4.9c.94-.44 1.72-1.62 1.8-3.18l.04-1.72h1.88l-.14 1.8c-.2 2.46-1.42 3.56-2.66 4.22.84 1.04 1.74 2.08 2.72 3.12l-.22 1.2h-8.3z'
                  fill='#fff'
                />
              </svg>
            )}
          </div>
          <div className='my-account-container'>
            {!isMobile && (
              <div className='my-account-details'>
                <span>
                  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M14.727 16.364c-.455.545-1.372 1.09-2.728 1.09-1.355 0-2.272-.545-2.727-1.09'
                      stroke='#fff'
                      stroke-width='1.5'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                    <circle cx='12.001' cy='9.818' r='5.455' stroke='#fff' stroke-width='1.5' />
                    <path
                      d='M5.453 19.637c1.091-2.182 3.293-4.364 6.545-4.364 3.253 0 5.455 2.182 6.546 4.363'
                      stroke='#fff'
                      stroke-width='1.5'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                  </svg>
                </span>
                {props?.idfStore?.userDetails?.first_name && props?.idfStore?.userDetails?.last_name && (
                  <span className='user-name'>
                    {props?.idfStore?.userDetails?.first_name + ' ' + props?.idfStore?.userDetails?.last_name}
                  </span>
                )}{' '}
              </div>
            )}

            <div onClick={() => setDisconnectShowPopup(true)} className='my-account-button'>
              <span>התנתקות</span>
            </div>
          </div>
        </div>
      </div>

      {renderMainPage()}
      <PopUp preventWrapperClose={true} showPopUp={showPopup} onClose={() => setShowPopup(false)} className=''>
        <ActionsErrorPopUp data={popupData} setShowPopUp={setShowPopup} />
      </PopUp>
      <PopUp preventWrapperClose={true} showPopUp={showDisconnectPopup} onClose={() => setDisconnectShowPopup(false)} className=''>
        <DisconnectPopUp
          setShowPopUp={setDisconnectShowPopup}
          handleDisconnect={() => prepareSameWindowUrlWithNavigateTo(Config.logoutPage, props.context)}></DisconnectPopUp>
      </PopUp>
    </div>
  );
};

const mapStateToProps = (state) => ({
  idfStore: state.idfSale,
  auth: state.authentication,
});

const mapDispatchToProps = { GetUserDetails, createWorkOrderAsync, refreshToken  , showAppLoader ,hideAppLoader};

export default connect(mapStateToProps, mapDispatchToProps)(IdfMainPage);
